module.exports = __webpack_public_path__ + "static/media/smiley-face-diploma.ee6b2d97.svg";